/* eslint-disable import/no-internal-modules */

import { getAnalytics as getAnalyticsFirebase, logEvent as _logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_Project_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_Storage_Bucket,
	messagingSenderId: import.meta.env.VITE_FIREBASE_Messaging_Seder_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
	measurementId: import.meta.env.VITE_FIREBASE_Measurement_ID,
};

const getAnalytics = () => {
	const app = initializeApp(firebaseConfig);
	return getAnalyticsFirebase(app);
};

function logEvent(eventName: string, params?: { [key: string]: unknown } | undefined) {
	try {
		if (process.env.NODE_ENV !== 'production') return;

		const analytics = getAnalytics();
		_logEvent(analytics, eventName, params);
	} catch (error) {
		/* empty */
		console.error(error);
	}
}

export { getAnalytics, logEvent };
